/* @flow */

import { rem } from 'polished';

import { antialiasing, pushDown } from 'src/shared/app/base/style/token/helper';
import { disabledOpacity } from 'src/shared/app/base/style/token/opacity';
import { aaDarkGrey } from '@e180/ui/lib/token/palette';
import { hoverSelector } from '@e180/ui/lib/token/selector';
import { baseFontSize } from '@e180/ui/lib/token/typography';

export default {
  root: {
    extend: antialiasing,

    color: ({ accentColor }: Object) => accentColor,
    backgroundColor: 'transparent',
    borderRadius: 0,
    stroke: 'currentColor',
    fill: 'currentColor',

    fontSize: rem(16, baseFontSize),
    lineHeight: 19 / 16,
    textDecoration: 'none',

    '&:visited': {},
    [hoverSelector]: {
      textDecoration: 'underline',
    },
    '&:active': {
      extend: pushDown,
    },
  },
  'root-isDimmed': {
    color: aaDarkGrey,

    '&:hover': {
      color: 'currentColor',
    },
    '&:active': {
      color: 'currentColor',
    },
  },
  'root-isDisabled': {
    opacity: disabledOpacity,

    pointerEvents: 'none',
  },
};
